import React from 'react'
import { PaymentInterval } from './Recurly'

interface Props {
    interval: PaymentInterval
    callback: (interval: PaymentInterval) => void
}

export default class ChangePaymentInterval extends React.Component<Props> {
    public render() {
        return (
            <div className="box">
                <div className="box-body">
                    <div className="row form-inline " style={{ marginBottom: '20px' }}>
                        <div className="col-md-4">
                            <input
                                id="monthly"
                                type="radio"
                                className="radio"
                                onChange={() => this.props.callback(PaymentInterval.Monthly)}
                                checked={this.props.interval === PaymentInterval.Monthly}
                            />
                            <label htmlFor="monthly">Pay monthly</label>
                        </div>

                        <div className="col-md-8">
                            <input
                                id="yearly"
                                type="radio"
                                className="radio"
                                onChange={() => this.props.callback(PaymentInterval.Yearly)}
                                checked={this.props.interval === PaymentInterval.Yearly}
                            />
                            <label htmlFor="yearly">Pay yearly (Get the 12th month free)</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
